import { PlanningModeEnum } from "shared/enums/globalEnums";
import { FieldValues } from "react-hook-form";

import { fcrNPlanningConfigurations } from "./config";
import { GenericPlanningConfig, FcrNEngagementSource, TrialEngagementEnum } from "../shared/types";
import { computeDefaultValuesGeneric } from "../shared/computeDefaultValues";

export function toGenericFcrNConfigs(): GenericPlanningConfig[] {
  return fcrNPlanningConfigurations.map((c) => {
    if (c.mode === PlanningModeEnum.soc_management) {
      return {
        name: c.name,
        mode: c.mode,
        durationInMinutes: c.durationInMinutes,
        targetSoc: c.targetSoc ?? 0,
        chronicleFilename: c.chronicleFilename ?? null,
      };
    }

    // fingrid_fcrn
    const engagementSource: FcrNEngagementSource =
      c.fcrn_engagement === TrialEngagementEnum.minimalOperationalPower ? "min" : "max";

    return {
      name: c.name,
      mode: PlanningModeEnum.fingrid_fcrn,
      durationInMinutes: c.durationInMinutes,
      engagementSource,
      chronicleFilename: c.chronicleFilename ?? null,
    };
  });
}

/**
 * Public helper for FCR-N screens: compute form default values through the generic engine.
 */
export function computeDefaultValuesFcrN(initialData: FieldValues) {
  const genericConfigs = toGenericFcrNConfigs();
  return computeDefaultValuesGeneric(genericConfigs, initialData);
}
